<template>
  <div v-if="loading" />
  <div v-else class="flex flex-col min-h-100dvh relative">
    <router-view />
    <global-popup
      v-if="popup.controller"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { addItem } from "./common/localStorage";
import { getClickID } from "@/utils/uniclick";
import ExperimentsTest from "@/utils/experiments-test";
import '@/assets/css/animations.css'
import { API } from "@/new_api";
import GlobalPopup from "@/components/popups/GlobalPopup.vue";
import UserIdMixin from "@/mixins/userIdMixin";


export default {
  components: { GlobalPopup },
  mixins: [UserIdMixin],
  data () {
    return {
      loading: true
    }
  },
  methods: {
    initAnalyticsParams() {
      const urlParams = new URLSearchParams(window.location.search);

      const sub1 = urlParams.get('sub1') || localStorage.getItem('sub1');
      const sub7 = urlParams.get('sub7') || localStorage.getItem('sub7');
      const utm_source = urlParams.get('utm_source') || localStorage.getItem('utm_source');

      if (sub1) localStorage.setItem('sub1', sub1);
      if (sub7) localStorage.setItem('sub7', sub7);
      if (utm_source) localStorage.setItem('utm_source', utm_source);

      this.$store.commit('SET_ANALYTICS_PARAMS', { sub1, sub7, utm_source });
    },
    setNewVersions (response) {
      if (response && response.assignment) {
        this.mixpanel.people.set({ [response.exp_id]: response.assignment } )
        this.mixpanel.track("Experiment Started", {
          [response.exp_id]: response.assignment
        })
      }
    },
    setContent() {
      const isTrackSelect = this.$tm('quiz.content')[0]?.check_track_question;

      if (isTrackSelect) {
        const trackName = localStorage.getItem('trackName') ? localStorage.getItem('trackName') : 'erection';
        const [initQuestion, tracks] = this.$tm('quiz.content');
        const content = [initQuestion, ...tracks[trackName]];
        this.$store.dispatch('setQuestions', content);
        this.$store.dispatch('setTracksInfo', {tracks});
      } else {
        this.$store.dispatch('setQuestions', this.$tm('quiz.content'));
      }
    },
    validateECP(ecp) {
      const pattern = /^E_C_P_/;
      return pattern.test(ecp);
    },
    async setClickId() {
      if (this.clickId) {
        this.setLoading(false)
        return
      }
      const urlParams = new URLSearchParams(window.location.search)
      const query = {
        date: this.$dayjs().toISOString(),
        queryClickId: urlParams.get('clickid'),
        cmpid: urlParams.get('cmpid'),
        sub3: urlParams.get('sub3'),
        sub2: urlParams.get('sub2'),
        sub1: urlParams.get('sub1')
      }

      const { queryClickId, cmpid, sub3, sub2, sub1, date } = query;

      const response = await ExperimentsTest({ campaignId: cmpid, user_uuid: this.uuid });

      if (response) {
        sessionStorage.setItem('clickIdRequest', true)
        this.setNewVersions(response);
        this.$versions.setVersions(response.payload);
        await this.$versions.loadContent(this.setContent);

        const uniclick_id = await getClickID(this.setLoading, response);
        if (uniclick_id) {
          const attribution = {
            click_time: date,
            redtrack_campaign_id: cmpid,
            campaign: sub3,
            adset: sub2,
            ad: sub1
          }
          this.mixpanel.people.set(attribution)
          this.mixpanel.track('Attribution', attribution)
        }
        if (queryClickId) {
          this.$store.dispatch('storeClickId', queryClickId);
          return
        } else {
          const cookiesClickID = this.$cookies.get('rtkclickid-store')
          const id = typeof uniclick_id === 'string' ? uniclick_id : cookiesClickID;
          this.$store.dispatch('storeClickId', id)
        }
        return
      }
    },
    setPriceFlow () {
      if (this.landingName) {
        this.mixpanel.people.set({"price_flow": this.landingName})
      }
    },
    setLoading (value) {
      this.loading = value;
    },
    checkIsPaid() {
      const finalPages = [
        'SexologyCourses',
        'IgnoringMentalSide',
        'PlanFinalTwo',
        'PlanFinalTwo_ios',
        'SexologySuperDisc',
        'VerifyAccountDetails',
        'Whatsapp'
      ]
      if (finalPages.includes(this.$route.name)) return
      const isPaid = this.$cookies.get('is_paid');
      if (isPaid) { this.$router.push({name: "Whatsapp"}) }
    },
  },
  computed: {
    ...mapGetters({
      content: 'getCurrentQuestion',
      clickId: 'clickId',
      uuid: 'userUuid',
      popup: 'getPopupInfo'
    }),
    landingName() {
      const urlParams = new URLSearchParams(window.location.search);
      const price_flow = urlParams.get('l')
      const price_flow_old = localStorage.getItem('l')

      const flow = price_flow_old ? price_flow_old : price_flow;

      return flow ? `v5_${flow}` : null
    },
  },
  async created() {
    const isClickIdRequest = sessionStorage.getItem('clickIdRequest')
    if (isClickIdRequest) {
      sessionStorage.removeItem('clickIdRequest')
    }
    this.checkIsPaid();

    if (window.navigator.platform == "iPhone") {
      // Считываем информацию о статусе в localStorage при загрузке страницы
      if (sessionStorage.getItem("store")) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(sessionStorage.getItem("store"))
          )
        );
      }
      // Сохраняем информацию в vuex в localStorage при обновлении страницы
      // window.addEventListener("beforeunload", () => {
      //   sessionStorage.setItem("store", JSON.stringify(this.$store.state));
      // });
    } else {
      // Считываем информацию о статусе в localStorage при загрузке страницы
      if (localStorage.getItem("store")) {
        this.$store.replaceState(
          Object.assign(
            {},
            this.$store.state,
            JSON.parse(localStorage.getItem("store"))
          )
        );
      }
      // Сохраняем информацию в vuex в localStorage при обновлении страницы
      // window.addEventListener("beforeunload", () => {
      //   localStorage.setItem("store", JSON.stringify(this.$store.state));
      // });
    }

    const lastVisitedPage = this.$cookies.get('last-visited-page');

    if (lastVisitedPage && lastVisitedPage !== '/' && this.$route.path === '/') {
      this.$router.push(lastVisitedPage);
    }
  },
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    this.initAnalyticsParams();
    this.$nextTick(() => {
      window.Chargebee.init({
        site: process.env.VUE_APP_CHARGEBEE_DOMAIN,
        publishableKey: process.env.VUE_APP_CHARGEBEE_KEY,
      });
      this.$store.commit('SET_FBCLID', fbclid);
    });
    await this.$router.isReady();
    this.generateUserIdMixin();
    await this.setClickId();
    // await this.$versions.setVersions();

    this.setPriceFlow();

    if (ttq) ttq.track('ViewContent')

    if (this.$route.name !== 'landing') {
      this.sendUserIdToMixpanelMixin();
    }

    this.mixpanel.people.set(
      {
        "Rplay ID": this.$tracker.getSessionID(),
        "Rplay URL": this.$tracker.getSessionURL()
      }
    )

    window.addEventListener('load', () => {
      // window.clarity("identify", this.uuid)?.then(
      //   (data) => this.mixpanel.people.set(
      //     {
      //       "Clarity ID": /_clck=(\w+)/.exec(window.document.cookie)[1],
      //       "Clarity URL": `https://clarity.microsoft.com/projects/view/h4y9gjjlug/impressions?UserId=is%3B${/_clck=(\w+)/.exec(window.document.cookie)[1]}&date=Last%2030%20days`
      //     }
      //     ));

      document.onreadystatechange = () => {
        let body = document.querySelector('body')
        body.classList.add('fixed');
        if (document.readyState == "complete") {
          body.classList.remove('fixed');
          let fbp = /_fbp=(fb\.1\.\d+\.\d+)/.exec(window.document.cookie);
          if (fbp && fbp[1]) {
            addItem("fbp", fbp[1]);
          }
          let fbc = /_fbc=(fb\.1\.\w+\.\w+)/.exec(window.document.cookie);
          if ((fbc && fbc[1])) {
            addItem("fbc", fbc[1]);
            this.$store.commit('SET_FBCLID', fbc[1]);
          }
          let ttclid = /ttclid=(E.C.P.\w+)/.exec(window.document.cookie);
          if (ttclid && ttclid[1]) {
            addItem("ttclid", ttclid[1]);
          }
        }
      };
      API.POSTBACK.postback({
        click_id: this.clickId,
        sum: 0,
        type: 'Quiz Start Screen Shown'
      });
    })

    const mixpanelMin = urlParams.get('mixmin')
    if (mixpanelMin != null) {
      localStorage.setItem('mixmin', mixpanelMin)
    }
    if (localStorage.getItem('mixmin') == 1) {
      this.mixpanel.people.set({"Minimal Mixpanel": true})
      this.mixpanel.disable()
    } else {
      this.mixpanel._flags.disable_all_events = false
    }

    const version = urlParams.get("ver");
    if (version != null) {
      // addItem("ver", parseInt(version));
      this.mixpanel.people.set({"Version": version})
    } else {
      if (localStorage.getItem('ver') == null) {
        this.mixpanel.people.set({"Version": 1})
      }
    }
    this.mixpanel.people.set({Build: 2})

    this.mixpanel.people.set({ Init: "-" });

    // localStorage.removeItem('sub1')
    // localStorage.removeItem('sub7')
    // localStorage.removeItem('utm_source')

    const refId = urlParams.get('ref_id');

    if (refId && this.validateECP(refId)) {
      localStorage.setItem('tiktok_click_id', refId);
    }


    gtag("get", "G-7MV4FLS470", "client_id", (clientID) => {
      addItem("ga_user_id", clientID);
    });
    gtag("get", "G-7MV4FLS470", "wbraid", (wbraid) => {
      addItem("ga_wbraid", wbraid);
    });
    gtag("get", "G-7MV4FLS470", "gbraid", (gbraid) => {
      addItem("ga_gbraid", gbraid);
    });
    gtag("get", "G-7MV4FLS470", "gclid", (gclid) => {
      addItem("ga_gclid", gclid);
    });
  },

  beforeMount() {
    this.$versions.loadContent(this.setContent);
  },

  watch: {
    '$route.path'(toPath) {
      if (toPath !== '/') {
        this.$cookies.set('last-visited-page', toPath, 900);
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.translate-enter-active,
.translate-leave-active {
  transition: all 0.65s ease;
}

.translate-enter-from,
.translate-leave-to {
  opacity: 0;
}

.dark-theme {
  background-color: #111113;
}

.light-theme {
  background-color: #fff;
}
</style>
